// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09ca527e","239":"1796140d","453":"e736bcab","732":"c6b9b20f"}[chunkId] + ".chunk.js";
};